let csrfToken: string | undefined;

export const setCsrfToken = (token: string) => {
  csrfToken = token;

  try {
    sessionStorage.setItem("csrfToken", token);
  } catch (e) {
    console.warn("Could not store CSRF token in sessionStorage", e);
  }
};

export const removeCsrfToken = () => {
  csrfToken = undefined;
  try {
    sessionStorage.removeItem("csrfToken");
  } catch (e) {
    console.warn("Could not remove CSRF token from sessionStorage", e);
  }
};

export const getCsrfToken = (): string | undefined => {
  if (csrfToken) {
    return csrfToken;
  }

  try {
    const storedToken = sessionStorage.getItem("csrfToken");
    if (storedToken) {
      csrfToken = storedToken;
      return storedToken;
    }
  } catch (e) {
    console.warn("Could not retrieve CSRF token from sessionStorage", e);
  }

  return undefined;
};
